export const shortenAddress = (inputString: string) => {
  if (inputString.length <= 9) {
    return inputString;
  } else {
    return inputString.slice(0, 6) + '...' + inputString.slice(-3);
  }
};
